import { render, staticRenderFns } from "./DataTableDataItem.vue?vue&type=template&id=c8bf04c2&scoped=true&"
import script from "./DataTableDataItem.vue?vue&type=script&lang=js&"
export * from "./DataTableDataItem.vue?vue&type=script&lang=js&"
import style0 from "./DataTableDataItem.vue?vue&type=style&index=0&id=c8bf04c2&scoped=true&lang=css&"
import style1 from "../../assets/style/base.css?vue&type=style&index=1&id=c8bf04c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bf04c2",
  null
  
)

export default component.exports